import {
  AlertCircle,
  AlertTriangle,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowNarrowLeft,
  ArrowRight,
  ArrowUp,
  Bank,
  BankNote02,
  BarChartSquare02,
  Bell01,
  Calendar,
  Car01,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronSelectorVertical,
  ChevronUp,
  ClockFastForward,
  Code01,
  Copy01,
  CreditCard01,
  CurrencyDollar,
  DotsVertical,
  Download01,
  Edit02,
  Eye,
  EyeOff,
  File04,
  Flag06,
  HelpCircle,
  HomeLine,
  Image01,
  InfoCircle,
  LinkBroken02,
  List,
  Loading01,
  Lock01,
  LockUnlocked03,
  LogOut01,
  MagicWand01,
  Mail01,
  MarkerPin01,
  Menu02,
  MinusCircle,
  Paperclip,
  PasscodeLock,
  Phone,
  Phone01,
  Placeholder,
  Plus,
  RefreshCw01,
  RefreshCw02,
  SearchLg,
  SearchSm,
  Settings01,
  Share04,
  ShieldTick,
  Stars01,
  SwitchHorizontal01,
  Trash02,
  TrendUp01,
  Type02,
  User01,
  X,
  Zap,
  ZoomIn,
} from '@untitledui/icons';

import { createIcon } from './createIcon';

export const AlertCircleIcon = createIcon(AlertCircle);
export const AlertTriangleIcon = createIcon(AlertTriangle);
export const ArchiveIcon = createIcon(Archive);
export const ArrowDownIcon = createIcon(ArrowDown);
export const ArrowLeftIcon = createIcon(ArrowLeft);
export const ArrowNarrowLeftIcon = createIcon(ArrowNarrowLeft);
export const ArrowRightIcon = createIcon(ArrowRight);
export const ArrowUpIcon = createIcon(ArrowUp);
export const BankIcon = createIcon(Bank);
export const BankNoteIcon = createIcon(BankNote02);
export const BarChartIcon = createIcon(BarChartSquare02);
export const BellIcon = createIcon(Bell01);
export const CalendarIcon = createIcon(Calendar);
export const CarIcon = createIcon(Car01);
export const CheckIcon = createIcon(Check);
export const CheckCircleIcon = createIcon(CheckCircle);
export const ChevronDownIcon = createIcon(ChevronDown);
export const ChevronLeftIcon = createIcon(ChevronLeft);
export const ChevronRightIcon = createIcon(ChevronRight);
export const ChevronSelectorIcon = createIcon(ChevronSelectorVertical);
export const ChevronUpIcon = createIcon(ChevronUp);
export const ClockFastForwardIcon = createIcon(ClockFastForward);
export const CodeIcon = createIcon(Code01);
export const CopyIcon = createIcon(Copy01);
export const CreditCardIcon = createIcon(CreditCard01);
export const DollarIcon = createIcon(CurrencyDollar);
export const DotsVerticalIcon = createIcon(DotsVertical);
export const DownloadIcon = createIcon(Download01);
export const EditIcon = createIcon(Edit02);
export const EyeIcon = createIcon(Eye);
export const EyeOffIcon = createIcon(EyeOff);
export const FileIcon = createIcon(File04);
export const FlagIcon = createIcon(Flag06);
export const HelpCircleIcon = createIcon(HelpCircle);
export const HomeIcon = createIcon(HomeLine);
export const ImageIcon = createIcon(Image01);
export const InfoCircleIcon = createIcon(InfoCircle);
export const LinkBrokenIcon = createIcon(LinkBroken02);
export const ListIcon = createIcon(List);
export const LoadingIcon = createIcon(Loading01);
export const LockIcon = createIcon(Lock01);
export const LockUnlockedIcon = createIcon(LockUnlocked03);
export const LogOutIcon = createIcon(LogOut01);
export const MagicWandIcon = createIcon(MagicWand01);
export const MailIcon = createIcon(Mail01);
export const MarkerPinIcon = createIcon(MarkerPin01);
export const MenuIcon = createIcon(Menu02);
export const MinusCircleIcon = createIcon(MinusCircle);
export const PaperclipIcon = createIcon(Paperclip);
export const PasscodeLockIcon = createIcon(PasscodeLock);
// Analog handset glyph. Note: `PhoneIcon` (below) is the Untitled `Phone01`
// smartphone — use this one when you want the classic receiver shape.
export const PhoneHandsetIcon = createIcon(Phone);
export const PhoneIcon = createIcon(Phone01);
export const PlaceholderIcon = createIcon(Placeholder);
export const PlusIcon = createIcon(Plus);
export const RecurringIcon = createIcon(RefreshCw01);
export const RefreshIcon = createIcon(RefreshCw02);
export const LargeSearchIcon = createIcon(SearchLg);
export const SmallSearchIcon = createIcon(SearchSm);
export const SettingsIcon = createIcon(Settings01);
export const ShareIcon = createIcon(Share04);
export const ShieldTickIcon = createIcon(ShieldTick);
export const StarsIcon = createIcon(Stars01);
export const SwitchHorizontalIcon = createIcon(SwitchHorizontal01);
export const TrashIcon = createIcon(Trash02);
export const TrendUpIcon = createIcon(TrendUp01);
export const TypeIcon = createIcon(Type02);
export const UserIcon = createIcon(User01);
export const CloseIcon = createIcon(X);
export const ZapIcon = createIcon(Zap);
export const ZoomInIcon = createIcon(ZoomIn);
